import {CSSProperties} from "react";

type Props = {
    gridTemplateRows?: string;
    gridTemplateColumns?: string;
    gridTemplate?: string;
    gap?: number;
    columnGap?: number;
    rowGap?: number;
    children: any;
    style?: CSSProperties;
    className?: string;
}
const Grid = (props: Props) => {

    return (
        <div style={{display: 'grid', gridTemplate: props.gridTemplate, gridTemplateRows: props.gridTemplateRows, gridTemplateColumns: props.gridTemplateColumns, gap: props.gap, columnGap: props.columnGap, rowGap: props.rowGap, ...props.style}} className={props.className}>
            {props.children}
        </div>
    )

}

export default Grid